// convert yyyy-mm-dd hh:mm:ss to yyyy-mm-ddThh:mm:ssZ
const convertTimestampToISO = (timestamp) => timestamp.replace(/\s/, 'T').concat('Z');

export default convertTimestampToISO;
